import { Section, Overline, QuoteBanner, Card, IconBadge } from "../components/Shared";
import { IMAGES } from "../lib/assets";
import { Target, Leaf, Award } from "lucide-react";
import { Seo } from "../components/Seo";

const CRUMBS = [["About", "/about"]];

const VALUES = [
  { icon: Target, title: "Accuracy First", desc: "Survey-grade equipment and rigorous QA mean you can trust every number and contour we deliver." },
  { icon: Leaf, title: "Environmental Stewardship", desc: "Healthy waterbodies matter. Our data supports responsible vegetation, sediment and habitat management." },
  { icon: Award, title: "Full-Service, Always", desc: "We handle the fieldwork, processing and delivery so your team can focus on decisions, not data collection." },
];

export default function About() {
  return (
    <>
      <Seo page="about" breadcrumbs={CRUMBS} />
      <Section className="pt-36">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <Overline>About Lake Monitor AI</Overline>
            <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight leading-[1.1]">
              Mapping water, so you can manage it
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-slate-700 leading-relaxed">
              Lake Monitor AI is a full-service lake and reservoir mapping company serving the United States and
              Canada. We combine survey-grade sonar, GPS and modern processing to turn any waterbody into clear,
              reliable maps and reports.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Our mission is simple: make the underwater world visible and actionable for the people who care for
              it — water districts, communities, associations and landowners alike. We travel to your site, do the
              work, and deliver results you can act on with confidence.
            </p>
          </div>
          <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-xl">
            <img src={IMAGES.bathymetric} alt="Bathymetric depth map" className="w-full object-cover aspect-square" />
          </div>
        </div>
      </Section>

      <Section className="pt-0">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {VALUES.map((v) => (
            <Card key={v.title} className="p-8">
              <IconBadge icon={v.icon} className="mb-5" />
              <h3 className="text-xl font-semibold text-slate-900">{v.title}</h3>
              <p className="text-slate-600 mt-3 leading-relaxed">{v.desc}</p>
            </Card>
          ))}
        </div>
      </Section>

      <QuoteBanner />
    </>
  );
}
